export default __webpack_public_path__ + "static/media/shape_round.e2c23217.png";